<template>
  <div>
    <div class="w-full mb-4">
      <p class="text-sm text-gray-500 leading-relaxed text-justify">{{ form.description }}</p>
    </div>

    <div class="flex flex-col space-y-4">
      <p class="font-medium text-gray-700 mb-2">{{ $t('select_lines_to_show_in_report') }}</p>
      
      <div class="flex justify-between items-center w-full">
        <span class="text-gray-700">{{ $t('baseline') }}</span>
        <b-switch size="is-small" v-model="form.settings.baseLine"/>
      </div>

      <div class="flex justify-between items-center w-full">
        <span class="text-gray-700">{{ $t('baseline_latest') }}</span>
        <b-switch size="is-small" v-model="form.settings.lastPlanned"/>
      </div>

      <div class="flex justify-between items-center w-full">
        <span class="text-gray-700">{{ $t('executed1') }}</span>
        <b-switch size="is-small" v-model="form.settings.actual"/>
      </div>
    </div>
  </div>
</template>

<script>
import { saveConfigPage } from '../services/report-detail.service.js';

export default {
  name: "LineSelectorConfigForm",

  props: {
    initialData: {
      type: Object,
      default: () => ({})
    },
    reportConfigs: {
      type: Object,
      default: () => ({})
    },
  },

  data() {
    const settings = this.initialData.settings || {};
    return {
      form: {
        ...this.initialData,
        settings: {
          ...settings,
          baseLine: settings.baseLine !== undefined 
            ? settings.baseLine 
            : true,
          lastPlanned: settings.lastPlanned !== undefined 
            ? settings.lastPlanned 
            : true,
          actual: settings.actual !== undefined 
            ? settings.actual 
            : true,
        }
      }
    };
  },

  methods: {
    submit() {
      saveConfigPage(this.form, this.reportConfigs)
      this.$emit('epc-save', this.form);
    },
  }
}
</script>